import { api } from "./client";
import type { AuthResponse } from "@/types/auth";

interface EmailTokenPayload {
  email: string;
}

interface EmailVerifyPayload {
  token: string;
}

interface GoogleLoginPayload {
  credential: string;
}

/** Always 202 for well-formed input (no account enumeration); 429 when rate-limited. */
export const requestEmailToken = (data: EmailTokenPayload) =>
  api.post("/auth/email/request", data, {
    skipAuth: true,
    serviceId: null,
  });

/**
 * First-time emails are auto-registered here. 410 for an expired link, 400 for
 * an invalid or never-issued token.
 */
export const verifyEmailToken = (data: EmailVerifyPayload) =>
  api.post<AuthResponse>("/auth/email/verify", data, {
    skipAuth: true,
    serviceId: null,
  });

/** Unknown emails auto-provision an org + user, like first-time magic-link sign-in. */
export const loginWithGoogle = (data: GoogleLoginPayload) =>
  api.post<AuthResponse>("/auth/google", data, {
    skipAuth: true,
    serviceId: null,
  });
